// PrivateCouncilTestimonials.jsx

import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../asstes/styles/privateCouncilTestimonials.scss";

const testimonials = [
  {
    id: 1,
    quote:
      "The Private Council is not an experience. It is a confrontation with answerability.",
    author: "BHUPENDRA CHAUDHARY",
  },
  {
    id: 2,
    quote:
      "Clarity without courage is still avoidance.",
    author: "PRIVATE COUNCIL",
  },
  {
    id: 3,
    quote:
      "Leadership begins where certainty ends.",
    author: "THE THRESHOLD",
  },
];

const itemVariants = {
  hidden: {
    opacity: 0,
    y: 40,
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
    },
  },
};

const PrivateCouncilTestimonials = () => {

  const [active, setActive] = useState(0);

  // NEXT
  const nextSlide = () => {
    setActive((prev) =>
      prev === testimonials.length - 1 ? 0 : prev + 1
    );
  };

  // PREVIOUS
  const prevSlide = () => {
    setActive((prev) =>
      prev === 0 ? testimonials.length - 1 : prev - 1
    );
  };

  // AUTO SLIDER
  useEffect(() => {

    const interval = setInterval(() => {
      nextSlide();
    }, 5000);

    return () => clearInterval(interval);

  }, []);

  return (
    <section className="pc-testimonials-section pd-common">

      {/* BACKGROUND EFFECTS */}
      <div className="pc-grid-pattern"></div>
      <div className="pc-glow glow-left"></div>
      <div className="pc-glow glow-right"></div>

      <div className="container">

        <div className="row align-items-center">

          {/* LEFT SIDE */}
          <div className="col-lg-7">

            <motion.div
              className="pc-left-content"
              initial={{
                opacity: 0,
                y: 60,
              }}
              whileInView={{
                opacity: 1,
                y: 0,
              }}
              transition={{
                duration: 1,
              }}
              viewport={{ once: true }}
            >

              <div className="heading-wrapper">

                <span className="mini-title">
                  THE NATURE OF THE SPACE
                </span>

                <h2 className="pc-heading-title">
                  What This <span>Is</span>
                </h2>

                <p>
                  The Private Council is the form through which
                  Dr.Bhupendra Chaudhary engages in a single,
                  direct engagement constructed without audience.
                </p>

                <p>
                  Nothing is promised. Nothing is offered.
                  The Council forms and then dissolves.
                </p>

              </div>

              {/* FEATURE POINTS */}
              <motion.div
                className="pc-footer-points"
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
                variants={{
                  hidden: {},
                  show: {
                    transition: {
                      staggerChildren: 0.2,
                    },
                  },
                }}
              >

                {/* ITEM */}
                <motion.div
                  className="pc-feature-item"
                  variants={itemVariants}
                  whileHover={{
                    y: -8,
                  }}
                >

                  <motion.div
                    className="pc-icon-circle"
                    whileHover={{
                      scale: 1.08,
                      rotate: 5,
                    }}
                    transition={{
                      type: "spring",
                      stiffness: 200,
                    }}
                  >
                    <i className="bi bi-shield-lock-fill"></i>
                  </motion.div>

                  <div className="pc-feature-content">
                    <h6>PRIVATE</h6>
                    <p>Confidential Engagement</p>
                  </div>

                </motion.div>

                <div className="pc-divider"></div>

                {/* ITEM */}
                <motion.div
                  className="pc-feature-item"
                  variants={itemVariants}
                  whileHover={{
                    y: -8,
                  }}
                >

                  <motion.div
                    className="pc-icon-circle"
                    whileHover={{
                      scale: 1.08,
                      rotate: -5,
                    }}
                    transition={{
                      type: "spring",
                      stiffness: 200,
                    }}
                  >
                    <i className="bi bi-lightning-charge-fill"></i>
                  </motion.div>

                  <div className="pc-feature-content">
                    <h6>DIRECT</h6>
                    <p>Clear Strategic Dialogue</p>
                  </div>

                </motion.div>

                <div className="pc-divider"></div>

                {/* ITEM */}
                <motion.div
                  className="pc-feature-item"
                  variants={itemVariants}
                  whileHover={{
                    y: -8,
                  }}
                >

                  <motion.div
                    className="pc-icon-circle"
                    whileHover={{
                      scale: 1.08,
                      rotate: 5,
                    }}
                    transition={{
                      type: "spring",
                      stiffness: 200,
                    }}
                  >
                    <i className="bi bi-eye-slash-fill"></i>
                  </motion.div>

                  <div className="pc-feature-content">
                    <h6>WITHOUT AUDIENCE</h6>
                    <p>No Performance. No Noise.</p>
                  </div>

                </motion.div>

              </motion.div>

            </motion.div>

          </div>

          {/* RIGHT SIDE */}
          <div className="col-lg-5">

            <div className="pc-quote-wrapper">

              <div className="pc-quote-card">

                {/* ONLY INNER CONTENT ANIMATES */}
                <AnimatePresence mode="wait">

                  <motion.div
                    key={testimonials[active].id}
                    className="pc-quote-inner"
                    initial={{
                      opacity: 0,
                      y: 40,
                    }}
                    animate={{
                      opacity: 1,
                      y: 0,
                    }}
                    exit={{
                      opacity: 0,
                      y: -40,
                    }}
                    transition={{
                      duration: 0.6,
                    }}
                  >

                    <div className="pc-quote-icon">
                      <i className="bi bi-quote"></i>
                    </div>

                    <p className="pc-quote">
                      “{testimonials[active].quote}”
                    </p>

                    <div className="pc-quote-line"></div>

                    <h5 className="pc-author">
                      {testimonials[active].author}
                    </h5>

                  </motion.div>

                </AnimatePresence>

              </div>

              {/* CONTROLS */}
              <div className="pc-slider-controls">

                <button onClick={prevSlide}>
                  <i className="bi bi-arrow-left"></i>
                </button>

                <div className="pc-dots">

                  {testimonials.map((_, index) => (
                    <span
                      key={index}
                      className={
                        active === index ? "active" : ""
                      }
                    ></span>
                  ))}

                </div>

                <button onClick={nextSlide}>
                  <i className="bi bi-arrow-right"></i>
                </button>

              </div>

            </div>

          </div>

        </div>

      </div>

    </section>
  );
};

export default PrivateCouncilTestimonials;